import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=f48290b0&scoped=true"
import script from "./LabelSelector.vue?vue&type=script&lang=js"
export * from "./LabelSelector.vue?vue&type=script&lang=js"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=f48290b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48290b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f48290b0')) {
      api.createRecord('f48290b0', component.options)
    } else {
      api.reload('f48290b0', component.options)
    }
    module.hot.accept("./LabelSelector.vue?vue&type=template&id=f48290b0&scoped=true", function () {
      api.rerender('f48290b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/LabelSelector.vue"
export default component.exports